// extracted by mini-css-extract-plugin
module.exports = {"container":"ReferralErrorPage_container__3r6hf","title":"ReferralErrorPage_title__21xJB","description":"ReferralErrorPage_description__okT6v"};